import * as angular from 'angular';
import { config } from 'angular/utils/config';
import { AuthService } from 'app/_services/auth.service';

(function () {
    'use strict';

    angular.module('app').directive('pkpPlaceBid', pkpPlaceBid);

    /**
     * @author frbomke.btc
     * @ngInject
     */
    function pkpPlaceBid(
        authService: AuthService,
        DATES,
        auctionResource,
        $location: ng.ILocationService,
        createProposalService,
        createComfortBidService
    ) {
        return {
            restrict: 'E',
            scope: {
                nwp: '=',
                actions: '=',
                auctions: '=?',
                showDetails: '=?',
                lazyLoad: '=?',
                runtimeFrom: '=?',
                runtimeTo: '=?'
            },
            template: require('app/_directives/pkp-place-bid.directive.html'),
            link: linkFn
        };

        function linkFn(scope) {
            scope.DATES = DATES;
            scope.getAuctions = getAuctions;
            scope.goToAuctionBid = goToAuctionBid;
            scope.getRegularFcfsUrl = getRegularFcfsUrl;
            scope.getDirectFcfsUrl = getDirectFcfsUrl;
            scope.createTradeProposal = createTradeProposal;
            scope.getComfortBidUrl = getComfortBidUrl;
            scope.effectiveActions = [];
            scope.hasDropdown = false;
            scope.isLoggedIn = false;
            scope.isUsedOnDashboard = $location.path().includes('start');

            // Certain functionality is not available for cubic meter per hour configured network points.
            scope.hasCubicMeterPerHourConfigured =
                scope.nwp.physicalUnit === 'M3_H';

            if (angular.isUndefined(scope.lazyLoad)) {
                scope.lazyLoad = false;
            }

            if (angular.isUndefined(scope.showDetails)) {
                scope.showDetails = true;
            }

            authService.userLoginPromise.promise.then(function (loggedInUser) {
                scope.isLoggedIn = !!loggedInUser;

                // remove SHOW_NETWORK_POINT_DETAILS when showDetails===false
                scope.effectiveActions = scope.actions.filter(
                    (a) =>
                        a !== 'SHOW_NETWORK_POINT_DETAILS' || scope.showDetails
                );

                if (scope.isLoggedIn && !scope.hasCubicMeterPerHourConfigured) {
                    // add NEW_SURRENDER_REQUEST before SHOW_NETWORK_POINT_DETAILS
                    const indexOfDetails = scope.effectiveActions.indexOf(
                        'SHOW_NETWORK_POINT_DETAILS'
                    );
                    if (indexOfDetails > -1) {
                        scope.effectiveActions.splice(
                            indexOfDetails,
                            0,
                            'NEW_SURRENDER_REQUEST'
                        );
                    } else {
                        scope.effectiveActions.push('NEW_SURRENDER_REQUEST');
                    }
                }

                // since the new FCFS Service is active, remove the legacy action
                const indexToRemove =
                    scope.effectiveActions.indexOf('CREATE_FCFS_ORDER');
                if (indexToRemove > -1)
                    scope.effectiveActions.splice(indexToRemove, 1);

                scope.hasDropdown = scope.effectiveActions.length > 1;
            });
            function getAuctions() {
                if (scope.lazyLoad) {
                    scope.uiLoading = true;
                    auctionResource.query(
                        {
                            networkPoint: scope.nwp.id,
                            start: 0,
                            withoutBids: true,
                            phase: ['PUBLISHED', 'OPEN', 'CLOSED'],
                            runtimeFrom: moment().toISOString(),
                            runtimeTo: moment().add(20, 'years').toISOString()
                        },
                        function (res) {
                            scope.auctions = res.data;
                            scope.uiLoading = false;
                        },
                        function () {
                            scope.uiLoading = false;
                        }
                    );
                } else {
                    scope.uiLoading = false;
                }
            }

            function goToAuctionBid(
                auctionId,
                algorithmType,
                slot,
                phase,
                periodType,
                runtimeFrom,
                runtimeTo
            ) {
                if (algorithmType === 'LONG_TERM') {
                    $location.path('/auctions/' + auctionId + '/bid');
                }
                if (algorithmType === 'SHORT_TERM') {
                    $location
                        .path('/auctions/list')
                        .search('slot', slot)
                        .search('phase', phase)
                        .search('periodType', periodType)
                        .search('auctionId', auctionId)
                        .search('runtime-from', runtimeFrom)
                        .search('runtime-to', runtimeTo);
                }
            }
        }

        function getRegularFcfsUrl(networkPoint: NetworkPointDto) {
            return (
                config.appBaseUrl +
                '/transport/fcfs-booking/regular?networkPointId=' +
                networkPoint.networkPointUuid
            );
        }

        function getDirectFcfsUrl(networkPoint: NetworkPointDto) {
            return (
                config.appBaseUrl +
                '/transport/fcfs-booking/direct?networkPointId=' +
                networkPoint.networkPointUuid
            );
        }

        function createTradeProposal(netPoint: NetworkPointDto) {
            createProposalService.setNetworkPoint(netPoint);
        }

        function getComfortBidUrl(networkPointId: number) {
            return (
                config.appBaseUrl +
                '/transport/auctions/comfort-bids/create?networkPointId=' +
                networkPointId
            );
        }
    }
})();
